import React, { useState, useEffect } from "react";
export default function Loading({ data, children }) {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // ตรวจสอบว่ามีข้อมูลหรือไม่
    if (data.length > 0) {
      setIsLoading(false); // ถ้ามีข้อมูลให้หยุด loading
    } else {
      setIsLoading(true); // ถ้าไม่มีข้อมูลให้แสดง loading
    }
  }, [data]); // ทำงานเมื่อ `data` เปลี่ยนแปลง

  return (
    <div>
      {isLoading ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
          <p className="ml-3">กำลังโหลด...</p>
        </div>
      ) : (
        children // แสดง children เมื่อมีข้อมูล
      )}
    </div>
  );
}
